import { render, staticRenderFns } from "./barchart.vue?vue&type=template&id=1a2beb02&"
import script from "./barchart.vue?vue&type=script&lang=js&"
export * from "./barchart.vue?vue&type=script&lang=js&"
import style0 from "./barchart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports